import { createProvider } from '@nvision/services/data-provider';

import { identityClient } from '@/modules/auth';

import type { CompanyUsersFilters } from '../../models/company-users.model';
import { normalizeCompanyUsers } from './normalize';

export const fetchCompanyUsers = createProvider(
  (filters: CompanyUsersFilters, { signal }: { signal?: AbortController['signal'] } = {}) =>
    identityClient.users.getByCompany(filters.companyId),
).andThen((res) => normalizeCompanyUsers(res));
